import { fetchApi } from "@/lib/api-helpers";
import { z } from "zod";

export const agreementSchema = z.object({
  id: z.number(),
  required: z.boolean(),
  show_path: z.string(),
  title: z.string(),
});

export const agreementsResponseSchema = z.object({
  agreement: agreementSchema.extend({
    description: z.string(),
    language_iso: z.string(),
    company_logo: z.string(),
  }),
  meta: z.object({
    request_id: z.string(),
    timestamp: z.string(),
  }),
});

export type Agreement = z.infer<typeof agreementSchema>;

export async function fetchAgreements(id: string, language_iso: string) {
  return fetchApi({
    endpoint: `/agreements/${id}?language_iso=${language_iso}`,
    method: "GET",
    outputSchema: agreementsResponseSchema,
  });
}
